<template>
  <div :class="['sidebar-container', showLogo ? 'has-logo' : '']">
    <sidebar-logo :collapse="sidebarCollapse" v-if="showLogo"></sidebar-logo>
    <el-scrollbar class="side-bar" ref="sidebar">
      <el-menu
        :collapse="sidebarCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="true"
        :default-active="activeIndex"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        @select="handleSelect"
        class="menu-container"
        id="sidebar"
      >
        <!-- <sidebar-item v-for="item in menus " :item="item" :key="item.id"></sidebar-item> -->
        <sidebar-item
          v-for="item in menuList"
          :item="item"
          :key="item.id"
        ></sidebar-item>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import variables from "@/styles/variables.scss";
import SidebarLogo from "./Logo";
import SidebarItem from "./SidebarItem";
import menus from "./menuData";
export default {
  name: "SideBar",
  data(){
    return {
      menuList:{}
    }
  },
  mounted(){
    let id = JSON.parse(sessionStorage.getItem("userinfo")).id
    this.$http({
      url: this.$api.permissionuser + id,
      method: "GET",
    }).then(res => {
      if (res.data.code == 200) {
        this.menuList = res.data.data.permissions;//权限 路由
      }
    });
  },
  components: {
    SidebarLogo,
    SidebarItem
  },
  computed: {
    ...mapGetters(["sidebarCollapse", "showLogo"]),
    variables() {
      console.log("variables")
      return variables;
    },
    menus() {
      console.log("menus")
      return menus;
    },
    activeIndex() {
      console.log("activeIndex")
      return (
        this.$store.getters.activeIndex ||
        sessionStorage.getItem("activeIndex") ||
        "1"
      );
    }
  },
  methods: {
    // 改变选中的菜单项触发
    handleSelect(key, keypath) {
      // this.$store.dispatch("changeActiveIndex", key);
      sessionStorage.setItem("activeIndex", key);
    }
  }
};
</script>
